export default __webpack_public_path__ + "static/media/delivery.ea3fefd4.svg";